import { render, staticRenderFns } from "./relatorioAuxiliares.vue?vue&type=template&id=0a85c4a0"
import script from "./relatorioAuxiliares.vue?vue&type=script&lang=js"
export * from "./relatorioAuxiliares.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports